import { ICouponCodeFetch } from '../../interfaces/coupon';
import { getEnv } from '../utils/environment';
import { simpleFetch } from './customFetch';

interface GetCouponCodeDataProps {
  couponCode: string;
  plan: string;
  postalCode?: string;
  state?: string;
  country?: string;
  city?: string;
}

const getCouponCodeData = ({
  couponCode = '',
  plan = '',
  postalCode = '',
  state = '',
  country = '',
  city = '',
}: GetCouponCodeDataProps): Promise<ICouponCodeFetch> => {
  const queryParams = new URLSearchParams({
    planCode: plan,
    countryCode: country,
    postalCode,
    state,
    city,
  });
  return simpleFetch<ICouponCodeFetch>({
    uri: `${couponCode}?${queryParams.toString()}`,
    options: {
      method: 'GET',
      headers: {
        'fff-auth': 'V1.1',
      },
    },
    baseUrl: `${getEnv().couponUrl}`,
  });
};

export { getCouponCodeData };
